import React from 'react';
import PropTypes from 'prop-types';
import RankBrain2SidebarToggleButtonWithHover from 'RankBrain2SidebarToggleButton';
import { delimiterSeparatedToTitleCase } from 'Utils';
import SidebarGuideInfoSection from './SidebarGuideInfoSection';
import SidebarDownloadSection from './SidebarDownloadSection';
import SidebarSingleDownloadSection from './SidebarSingleDownloadSection';

const navBarContainerStyle = {
  position: 'relative',
  height: '100%',
  right: 0,
  top: 0,
  minWidth: 320,
  zIndex: 1,
};

const sectionListContainerStyle = {
  paddingLeft: 30,
  paddingRight: 30,
  height: '100%',
  position: 'relative',
};

const sectionListStyle = {
  listStyle: 'none',
  height: '100%',
  paddingLeft: 0,
};

export default class RankBrain2SidebarNavbar extends React.PureComponent {
  render() {
    const {
      activeSectionIdx,
      activeSectionItemIdx,
    } = this.props;
    let offset = 0;
    const sections = this.props.sections.map(
      (section, idx) => {
        const sectionNode = (
          <SidebarGuideInfoSection
            key={section.title}
            toggleProps={this.props.toggleProps}
            enableSectionOpen={this.props.enableSectionOpen}
            section={section}
            offset={offset}
            sectionOffset={idx}
            activeSectionIdx={activeSectionIdx}
            activeSectionItemIdx={activeSectionItemIdx}
          />
      );
        offset += section.sectionItems.length;
        return sectionNode;
      },
    );
    return (
      <div className="rank-brain-2-sidebar-navbar" style={navBarContainerStyle} >
        {
          this.props.includeToggleSideBar &&
            <RankBrain2SidebarToggleButtonWithHover {...this.props.toggleProps} />
        }
        {
          this.props.includeExcelDownload &&
            <SidebarSingleDownloadSection
              slug={this.props.slug}
              extension="xlsx"
              format="excel"
              heading="Free Download"
              subheading={delimiterSeparatedToTitleCase('-', this.props.slug)}
              text="Excel Spreadsheet"
            />
        }
        <SidebarDownloadSection
          slug={this.props.downloadSlug || this.props.slug}
        />
        <div
          className="rank-brain-2-sidebar-section-container nav-list-section"
          style={sectionListContainerStyle}
        >
          <ul className="rank-brain-2-sidebar-section-list" style={sectionListStyle}>
            {sections}
          </ul>
        </div>
      </div>
    );
  }
}

RankBrain2SidebarNavbar.defaultProps = {
  activeSectionIdx: 0,
  activeSectionItemIdx: 0,
  downloadSlug: '',
  enableSectionOpen: false,
  includeExcelDownload: '',
  includeToggleSideBar: false,
  sections: [],
};

RankBrain2SidebarNavbar.propTypes = {
  activeSectionIdx: PropTypes.number,
  activeSectionItemIdx: PropTypes.number,
  downloadSlug: PropTypes.string,
  enableSectionOpen: PropTypes.bool,
  includeExcelDownload: PropTypes.string,
  includeToggleSideBar: PropTypes.bool,
  sections: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  slug: PropTypes.string.isRequired,
  toggleProps: PropTypes.shape({
    toggleSideBar: PropTypes.func,
    includeText: PropTypes.bool,
    hoverImgSrc: PropTypes.string,
    imgSrc: PropTypes.string,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarNavbar/index.jsx